import React from 'react';

/**
 * NotificationContainer - DISABLED
 * 
 * This component has been disabled to prevent duplicate notifications.
 * All notifications are now handled by NotificationBar component only.
 * 
 * If you need toast notifications, use NotificationBar's banner feature instead.
 */
const NotificationContainer = () => {
  // Component disabled - return null to prevent rendering
  return null;
};

export default NotificationContainer;